var _path, _rect, _rect2, _rect3, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyRequested(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.999999C3.23858 0.999999 1 3.23858 0.999999 6C0.999999 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 0.999999Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 6 11)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 6 15)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 6 18)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 7 5)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 8H16.9C16.662 8.00085 16.434 8.09345 16.2661 8.25748C16.0983 8.42151 16.0042 8.64359 16.0045 8.87499L16 14.125C16.0007 14.3569 16.0958 14.579 16.2644 14.743C16.433 14.9069 16.6615 14.9993 16.9 15H24.1C24.3385 14.9993 24.567 14.9069 24.7356 14.743C24.9042 14.579 24.9993 14.3569 25 14.125V8.87499C24.9993 8.64314 24.9042 8.42099 24.7356 8.25705C24.567 8.09311 24.3385 8.0007 24.1 8ZM24.1 9.75007L20.5 11.9376L16.9 9.75007V8.87499L20.5 11.0625L24.1 8.87499V9.75007Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyRequested);
export default __webpack_public_path__ + "static/media/key_requested.3c5196febb8307e7caffb2c05d04a97c.svg";
export { ForwardRef as ReactComponent };